<!-- inputs -->
<div class="flex layout-col p-pane">
  <h4 class="text-title-medium">{{ 'lead-time.production-penalty' | translate }}</h4>
  <!-- process lead time -->
  @if (processLeadTimeSpec$ | async; as processLeadTimeSpec) {
    <div class="layout-col gap-sm">
      <mat-checkbox
        name="lead-time-ignore-work-hours"
        [checked]="processLTIgnoreWH$ | async"
        (change)="processLTIgnoreWH$.next($event.checked)"
      >
        {{ 'lead-time.independent-from-work-hours' | translate }}
      </mat-checkbox>
      @if (processLTIgnoreWH$ | async) {
        <mat-form-field>
          <mat-label>{{ 'lead-time.title' | translate }}</mat-label>
          <elder-period-input
            name="lead-time-period"
            [(isoValue)]="processLeadTimeSpec.independentProcessingLeadTime"
            (isoValueChange)="updateTotalPenalty()"
            [format]="'dd'"
          >
          </elder-period-input>
        </mat-form-field>
      } @else {
        <mat-form-field>
          <mat-label>{{ 'lead-time.title' | translate }}</mat-label>
          <elder-duration-input
            name="lead-time-duration"
            [(isoValue)]="processLeadTimeSpec.dependantProcessingLeadTime"
            (isoValueChange)="updateTotalPenalty()"
            [format]="'dd:hh:mm'"
          >
          </elder-duration-input>
        </mat-form-field>
      }
    </div>
  }

  @if (releaseAt$ | async; as releaseAt) {
    <!-- release schedule -->
    <div class="layout-col gap-sm">
      <h4 class="text-title-medium">{{ 'processPlan.release' | translate }}</h4>
      <mat-form-field>
        <elder-duration-input
          name="releaseAt"
          (valueChange)="emitReleaseAt($event)"
          [value]="releaseAt"
          [format]="'dd'"
        >
        </elder-duration-input>
      </mat-form-field>
    </div>
  }
</div>
